var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "community-dynamics-detail" }, [
    _c(
      "div",
      { staticClass: "page-header" },
      [
        _c("el-page-header", {
          attrs: { content: "社区动态详情" },
          on: { back: _vm.goBack },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "detail-content",
      },
      [
        _c(
          "el-card",
          { staticClass: "box-card" },
          [
            _c(
              "div",
              {
                staticClass: "clearfix card-header",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_c("span", { staticClass: "card-title" }, [_vm._v("动态详情")])]
            ),
            _vm._v(" "),
            _c(
              "el-form",
              { staticClass: "detail-form", attrs: { "label-width": "120px" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "bold-label",
                            attrs: { label: "编号：" },
                          },
                          [
                            _c("span", { staticClass: "detail-value" }, [
                              _vm._v(_vm._s(_vm.mergedDetailData.id)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "bold-label",
                            attrs: { label: "地点：" },
                          },
                          [
                            _c("span", { staticClass: "detail-value" }, [
                              _vm._v(_vm._s(_vm.mergedDetailData.storeName)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "bold-label",
                            attrs: { label: "信息：" },
                          },
                          [
                            _c("div", { staticClass: "user-info" }, [
                              _c("img", {
                                staticClass: "user-avatar",
                                attrs: {
                                  src: _vm.mergedDetailData.userpic,
                                  alt: "",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "user-text-content" }, [
                                _c("span", { staticClass: "user-name" }, [
                                  _vm._v(_vm._s(_vm.mergedDetailData.alias)),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "user-phone" }, [
                                  _vm._v(
                                    "(" +
                                      _vm._s(_vm.mergedDetailData.mobilePhone) +
                                      ")"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "publish-time" }, [
                                  _vm._v(
                                    "于 " +
                                      _vm._s(_vm.mergedDetailData.addTime) +
                                      " 发表"
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "bold-label",
                            attrs: { label: "赞：" },
                          },
                          [
                            _c("span", { staticClass: "detail-value" }, [
                              _vm._v(_vm._s(_vm.mergedDetailData.praiseNum)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "bold-label",
                            attrs: { label: "内容:" },
                          },
                          [
                            _c("div", { staticClass: "content-text" }, [
                              _vm._v(_vm._s(_vm.mergedDetailData.content)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.type == "5" && _vm.mergedDetailData.applyStatus > 1
                      ? _c(
                          "el-col",
                          {
                            staticClass: "audit-info-section",
                            attrs: { span: 24 },
                          },
                          [
                            _c(
                              "el-divider",
                              { attrs: { "content-position": "left" } },
                              [_vm._v("审核信息")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "bold-label",
                                        attrs: { label: "审核状态：" },
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                _vm.mergedDetailData
                                                  .applyStatus === 2
                                                  ? "danger"
                                                  : "success",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.mergedDetailData
                                                    .applyStatus === 2
                                                    ? "已拒绝"
                                                    : "已同意"
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "bold-label",
                                        attrs: { label: "审核时间：" },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "detail-value" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mergedDetailData
                                                  .reviewTime || "无"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "bold-label",
                                        attrs: { label: "审核理由：" },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "detail-value" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mergedDetailData
                                                  .rejectReason || "无"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type == "5" && _vm.mergedDetailData.applyStatus == 1
                      ? _c(
                          "el-col",
                          {
                            staticClass: "audit-form-section",
                            attrs: { span: 24 },
                          },
                          [
                            _c(
                              "el-divider",
                              { attrs: { "content-position": "left" } },
                              [_vm._v("审核操作")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form",
                              {
                                ref: "auditForm",
                                attrs: {
                                  model: _vm.auditForm,
                                  rules: _vm.auditRules,
                                  "label-width": "100px",
                                },
                              },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "审核结果",
                                              prop: "status",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio-group",
                                              {
                                                model: {
                                                  value: _vm.auditForm.status,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.auditForm,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "auditForm.status",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-radio",
                                                  { attrs: { label: "agree" } },
                                                  [_vm._v("同意")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-radio",
                                                  {
                                                    attrs: { label: "reject" },
                                                  },
                                                  [_vm._v("拒绝")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "审核理由",
                                              prop: "reason",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                rows: 4,
                                                placeholder: "请输入审核理由",
                                              },
                                              model: {
                                                value: _vm.auditForm.reason,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.auditForm,
                                                    "reason",
                                                    $$v
                                                  )
                                                },
                                                expression: "auditForm.reason",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: _vm.handleAuditSubmit,
                                                },
                                              },
                                              [_vm._v("审核")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.mergedDetailData.images && _vm.mergedDetailData.images.length > 0
          ? _c("el-card", { staticClass: "box-card" }, [
              _c(
                "div",
                {
                  staticClass: "clearfix card-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "card-title" }, [
                    _vm._v("图片信息"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "images-container" },
                _vm._l(_vm.mergedDetailData.images, function (img, index) {
                  return _c("el-image", {
                    key: index,
                    staticClass: "detail-image",
                    attrs: {
                      src: _vm.getImageUrl(img),
                      "preview-src-list": _vm.mergedDetailData.images.map(
                        _vm.getImageUrl
                      ),
                      fit: "cover",
                    },
                  })
                }),
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        this.type == 9
          ? _c(
              "el-card",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.commentLoading,
                    expression: "commentLoading",
                  },
                ],
                staticClass: "box-card comment-list-card",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix card-header",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("div", { staticClass: "comment-header-title" }, [
                      _c("i", {
                        staticClass: "el-icon-chat-line-round comment-icon",
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "card-title" }, [
                        _vm._v("评论列表"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "comment-count" }, [
                        _vm._v("(" + _vm._s(_vm.total) + ")"),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "commentListContainer",
                    staticClass: "comment-list-scroll-container",
                    on: { scroll: _vm.handleScroll },
                  },
                  [
                    _vm.commentList.length > 0
                      ? _c(
                          "div",
                          { staticClass: "comment-list" },
                          _vm._l(_vm.commentList, function (comment, index) {
                            return _c(
                              "div",
                              {
                                key: comment.commentId,
                                staticClass: "comment-item",
                                class: { "top-comment": comment.isTop === 1 },
                              },
                              [
                                _c("div", { staticClass: "comment-header" }, [
                                  _c("div", { staticClass: "user-info" }, [
                                    _c(
                                      "div",
                                      { staticClass: "avatar-container" },
                                      [
                                        _c("el-avatar", {
                                          staticClass: "user-avatar",
                                          attrs: {
                                            src: _vm.getImageUrl(
                                              comment.userpic
                                            ),
                                            alt: "",
                                            onerror:
                                              "this.src='https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng';this.onerror=null;",
                                          },
                                        }),
                                        _vm._v(" "),
                                        index % 3 === 0
                                          ? _c("div", {
                                              staticClass: "online-indicator",
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "user-details" }, [
                                      _c(
                                        "div",
                                        { staticClass: "user-name-row" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "user-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  comment.alias || "匿名用户"
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          comment.isTop === 1
                                            ? _c(
                                                "el-tag",
                                                {
                                                  staticClass: "top-tag",
                                                  attrs: {
                                                    type: "success",
                                                    size: "mini",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleToggleReplyTop(
                                                        comment
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-top",
                                                  }),
                                                  _vm._v(
                                                    "置顶\n                    "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          comment.isTop != 1
                                            ? _c(
                                                "el-tag",
                                                {
                                                  staticClass: "top-tag",
                                                  attrs: {
                                                    type: "danger",
                                                    size: "mini",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleToggleReplyTop(
                                                        comment
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-bottom",
                                                  }),
                                                  _vm._v(
                                                    "未置顶\n                    "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "user-meta" }, [
                                        comment.mobilePhone
                                          ? _c(
                                              "span",
                                              { staticClass: "user-phone" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-mobile-phone",
                                                }),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      comment.mobilePhone
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "comment-time" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-time",
                                            }),
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.formatDate(
                                                    comment.addTime
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "comment-stats" }, [
                                    _c(
                                      "div",
                                      { staticClass: "stat-item praise-count" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-thumb",
                                          class: { liked: comment.liked },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(comment.praiseNum || 0)
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "comment-content" }, [
                                  _c("div", { staticClass: "content-text" }, [
                                    _vm._v(_vm._s(comment.content)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "comment-actions" }, [
                                  _c("div", { staticClass: "action-left" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "reply-count",
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleReply(comment)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-chat-dot-round",
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(comment.replyCount || 0) +
                                            " 条回复\n                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "action-right" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "action-btn",
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDeleteReply(
                                                comment.commentId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete",
                                          }),
                                          _vm._v(
                                            "\n                  删除\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                comment.parentList &&
                                comment.parentList.length > 0 &&
                                comment.showReplies
                                  ? _c(
                                      "div",
                                      { staticClass: "reply-list" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "reply-list-header" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "reply-list-title",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-chat-dot-round",
                                                }),
                                                _vm._v(
                                                  "\n                  全部回复 (" +
                                                    _vm._s(comment.replyCount) +
                                                    ")\n                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          comment.parentList,
                                          function (reply, replyIndex) {
                                            return _c(
                                              "div",
                                              {
                                                key: reply.replyId,
                                                staticClass: "reply-item",
                                                class: {
                                                  "highlight-reply":
                                                    replyIndex === 0,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "reply-header",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "user-info",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "avatar-container",
                                                          },
                                                          [
                                                            _c("el-avatar", {
                                                              staticClass:
                                                                "user-avatar",
                                                              attrs: {
                                                                src: _vm.getImageUrl(
                                                                  reply.userpic
                                                                ),
                                                                alt: "",
                                                                size: "small",
                                                                onerror:
                                                                  "this.src='https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng';this.onerror=null;",
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            replyIndex % 4 === 0
                                                              ? _c("div", {
                                                                  staticClass:
                                                                    "online-indicator",
                                                                })
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "user-details",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "user-name-row",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "user-name",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        reply.alias ||
                                                                          "匿名用户"
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                reply.isAuthor
                                                                  ? _c(
                                                                      "el-tag",
                                                                      {
                                                                        staticClass:
                                                                          "author-tag",
                                                                        attrs: {
                                                                          type: "info",
                                                                          size: "mini",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                          作者\n                        "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "user-meta",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "reply-time",
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "el-icon-time",
                                                                    }),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm.formatDate(
                                                                            reply.addTime
                                                                          )
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "reply-stats",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "stat-item praise-count",
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-thumb",
                                                              class: {
                                                                liked:
                                                                  reply.liked,
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  reply.praiseNum ||
                                                                    0
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "reply-content",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "content-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(reply.content)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "reply-actions",
                                                  },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticClass:
                                                          "reply-btn",
                                                        attrs: {
                                                          type: "danger",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleDeleteReply(
                                                              reply.replyId
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-delete",
                                                        }),
                                                        _vm._v(
                                                          "\n                    删除\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        _vm._v(" "),
                                        comment.replyCount >
                                        comment.parentList.length
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "load-more-replies",
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass: "show-all-btn",
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showAllReply(
                                                          comment.commentId,
                                                          _vm.mergedDetailData
                                                            .id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-view",
                                                    }),
                                                    _vm._v(
                                                      "\n                  查看所有回复\n                "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        )
                      : _c("div", { staticClass: "no-comments" }, [
                          _c("div", { staticClass: "no-comments-content" }, [
                            _c("div", { staticClass: "empty-illustration" }, [
                              _c("i", {
                                staticClass:
                                  "el-icon-chat-line-round empty-icon",
                              }),
                            ]),
                            _vm._v(" "),
                            _c("h3", { staticClass: "empty-title" }, [
                              _vm._v("暂无评论"),
                            ]),
                          ]),
                        ]),
                  ]
                ),
                _vm._v(" "),
                _vm.scrollLoading
                  ? _c("div", { staticClass: "scroll-loading" }, [
                      _c("div", { staticClass: "loading-content" }, [
                        _c("i", {
                          staticClass: "el-icon-loading loading-icon",
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "loading-text" }, [
                          _vm._v("正在加载更多评论..."),
                        ]),
                      ]),
                    ])
                  : !_vm.commentPage.hasNextPage && _vm.commentList.length > 0
                  ? _c("div", { staticClass: "scroll-loading" }, [
                      _c("div", { staticClass: "no-more-content" }, [
                        _c("i", {
                          staticClass: "el-icon-finished finished-icon",
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "no-more-text" }, [
                          _vm._v("已经到底了，没有更多评论了"),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }